<template>
    <div class="touchoverlay" @mousedown="touchoverlay=true" v-if="touchcheck">
        <game-asset-v-3-bottom-button v-if="touchoverlay"></game-asset-v-3-bottom-button>
        <div class="closetouch" v-if="touchoverlay" @mousedown.stop="touchoverlay=false">{{__('games.close')}}</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                touchoverlay: false,
                touchcheck: false,
            }
        },
        mounted() {
            window.connection.subscribe(this);
            this.update(window.connection.lastUpdate);
        },
        methods: {
            update(data) {
                if (data == null) return;
                //touchoverlay check
                this.touchcheck = data.gameState.touchoverlay;
            },
            changeOverlay(t) {
                this.touchoverlay = t;
            },
        },
    }
</script>
